import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@docma-mm-core/config/config.service';
import { BasedataService } from '@docma-mm-core/shared/basedata.service';
import { catchError, Observable } from 'rxjs';
import { ProjectUserPermissions } from './project-user-permissions';



@Injectable()
export class PermissionService extends BasedataService {

  private projectUrl: string = '/projects';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getProjectUrl() {
    return super.getFullUrl(this.projectUrl);
  }


  getProjectPermissions(id: number): Observable<ProjectUserPermissions> {
    const endpoint = `${this.getProjectUrl()}/${id}/permissions`;
    return this.http
      .get<ProjectUserPermissions>(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
